module.exports = __webpack_public_path__ + "static/media/winZoleTwoAces_1.cea90252.png";